var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconEditUnFilled = function SvgIconEditUnFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.378 15.75h1.093L13 8.221l-1.093-1.093-7.529 7.529zm11.44-8.433-3-3.016.95-.948q.4-.4.947-.401.546 0 .947.4l1.114 1.114q.38.38.371.955a1.32 1.32 0 0 1-.387.956zM3.84 17.083a.76.76 0 0 1-.559-.236.76.76 0 0 1-.236-.559v-1.89q0-.152.054-.287a.8.8 0 0 1 .172-.254l8.623-8.623 3 3-8.623 8.623a.8.8 0 0 1-.253.172.8.8 0 0 1-.287.054zm8.62-9.402-.553-.553L13 8.221z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconEditUnFilled);
export { ForwardRef as ReactComponent };